<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div class="top-right-button-container">
            <b-button v-b-modal.client_form @click="edit = false" variant="primary" size="sm" class="top-right-button"
                      v-text="'ADD NEW'"/>
        </div>

        <div class="d-flex flex-row">
            <span class="iconsminds-family-sign mr-3 menu-icon-style" style="font-size: 23px;"/>

            <piaf-breadcrumb heading="Clients"/>

<!--            <p class="my-auto">-->
<!--                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                officiis quia quos rem totam vitae.-->
<!--            </p>-->
        </div>

        <div class="my-2">
            <div class="d-block d-md-inline-block pt-1">
                <b-dropdown :text="'Order by: ' + meta.order_by"
                            variant="outline-dark" class="mr-1 float-md-left btn-group" size="xs">

                    <b-dropdown-item v-for="(field,index) in table_fields.slice(0, -1)"
                                     v-if="field.sortable === true" :key="index"
                                     @click="changeOrderBy(field.key, field.label)">{{ field.label }}
                    </b-dropdown-item>
                </b-dropdown>

                <div class="search-sm d-inline-block float-md-left ml-1 align-top">
                    <b-input placeholder="Search" @input="searchClient" v-model="meta.search"/>
                </div>
            </div>

            <div class="float-md-right pt-1">
                <span class="text-muted text-small mr-1 mb-2">{{meta.from}}-{{meta.to}} of {{ meta.total }}</span>

                <b-dropdown right :text="meta.per_page.toString()" variant="outline-dark"
                            class="d-inline-block" size="xs">
                    <b-dropdown-item v-for="(size,index) in meta.page_sizes" :key="index"
                                     @click="changePageSize(size)">{{ size }}
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <div class="separator mb-4"></div>

        <b-card class="mb-4" :title="'List of Clients'">
            <b-refresh-button class="text-data-link" @click="refreshData"/>

            <b-table :key="tableKey" show-empty no-sort-reset class="vuetable" :sort-by="meta.sort_by"
                     :sort-desc="meta.sort_desc" @sort-changed="changeSorting" :per-page="meta.per_page"
                     :current-page="meta.current_page" :fields="table_fields" :items="fetchClients">

                <template v-slot:cell(id)="data">
                    <span v-text="data.item.data.attributes.code"/>
                </template>

                <template v-slot:cell(name)="data">
                    <router-link class="text-data-link" :to="'/hms/clients/' + data.item.links.self"
                                 v-text="data.item.data.attributes.name"/>
                </template>

                <template v-slot:cell(ssn)="data">
                    <span v-text="data.item.data.attributes.ssn"/>
                </template>

                <template v-slot:cell(gender)="data">
                    <span v-text="data.item.data.attributes.gender"/>
                </template>

                <template v-slot:cell(dob)="data">
                    <span v-text="data.item.data.attributes.dob"/>
                </template>

                <template v-slot:cell(status)="data">
                    <b-badge pill :style="clientStatusWidth(data.item.data.attributes.status)"
                             :variant="clientStatusColor(data.item.data.attributes.status)">
                        {{ data.item.data.attributes.status }}
                    </b-badge>
                </template>

                <template v-slot:cell(actions)="data">
                    <b-dropdown variant="empty" class="my-auto dropright" size="xs"
                                menu-class="mt-2" style="width: 75px;" right no-caret>
                        <template slot="button-content">
                            <i class="btn-circle simple-icon-options-vertical"/>
                        </template>

                        <b-dropdown-item :to="data.item.links.self">
                            Summary
                        </b-dropdown-item>

                        <b-dropdown-item @click="changeStatus(data.item)">
                            Change Status
                        </b-dropdown-item>

                        <b-dropdown-item @click="editClient(data.item.client_id)">
                            Edit
                        </b-dropdown-item>

                        <b-dropdown-item v-if="data.item.data.attributes.valid_referral" @click="reReferral(data.item)" size="sm" variant="outline-primary">
                            Re-referral
                        </b-dropdown-item>

                        <b-dropdown-item v-if="data.item.data.attributes.status === 'Referral' && !data.item.data.attributes.previous_admission" @click="deleteClient(data.item)">
                            Delete
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>

            <b-pagination size="sm" align="center" :total-rows="meta.total" :per-page="meta.per_page"
                          v-model="meta.current_page">
                <template v-slot:next-text>
                    <i class="simple-icon-arrow-right"/>
                </template>

                <template v-slot:prev-text>
                    <i class="simple-icon-arrow-left"/>
                </template>

                <template v-slot:first-text>
                    <i class="simple-icon-control-start"/>
                </template>

                <template v-slot:last-text>
                    <i class="simple-icon-control-end"/>
                </template>
            </b-pagination>
        </b-card>

        <ClientFormModal :edit="edit" @updated="tableKey++"/>

        <ClientOtherModal v-if="client" :client="client" mode="status" @updated="tableKey++"/>

        <ClientRereferralModal v-if="referralClicked" :client="client" @closed="referralClicked = false"
                               @updated="tableKey++"/>

        <ClientDeleteModal v-if="client" :client="client" mode="client" @deleted-client="tableKey++"/>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import ClientFormModal from "./modals/ClientFormModal";
    import ClientOtherModal from "./modals/ClientOtherModal";
    import ClientDeleteModal from "./modals/ClientDeleteModal";
    import ClientRereferralModal from "./modals/ClientRereferralModal";

    export default {
        name: "ClientsList",

        components: {
            ClientFormModal,
            ClientOtherModal,
            ClientDeleteModal,
            ClientRereferralModal,
        },

        data() {
            return {
                loading: true,
                tableKey: 0,
                edit: false,
                client: null,
                referralClicked: false,
            }
        },

        computed: {
            ...mapGetters({
                table_fields: 'getClientTableFields',
                meta: 'getClientsMeta',
            }),
        },

        methods: {
            changeSorting(event) {
                (event.sortDesc ? this.meta.sort = 'desc' : this.meta.sort = 'asc') && (this.meta.sort_by = event.sortBy);
            },

            changeOrderBy(key, label) {
                this.meta.order_by = label;
                this.meta.sort_by = key;
            },

            changePageSize(per_page) {
                this.meta.per_page = per_page;
            },

            searchClient: _.debounce(function (event) {
                // if (this.meta.search && this.meta.search.length >= 3) {
                    this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
                // }
            }, 300),

            refreshData() {
                this.$store.commit('resetClientsMeta');
                this.meta.current_page === 1 ? this.tableKey++ : this.meta.current_page = 1;
            },

            fetchClients() {
                return this.$store.dispatch('fetchClients')
                    .then(clients => {
                        return clients.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            clientStatusColor: status => {
                if (status.toLowerCase() === 'referral') return 'warning'
                else if (status.toLowerCase() === 'admitted') return 'success'
                else if (status.toLowerCase() === 'transferred') return 'info'
                else if (status.toLowerCase() === 'discharged') return 'danger'
                else if (status.toLowerCase() === 'duplicate') return 'dark'
                else return 'light'
            },

            clientStatusWidth: status => {
                if (status.toLowerCase() === 'hospitalized - covid-19' ||
                    status.toLowerCase() === 'hospitalized - other') return 'width: 133px'

                else return 'width: 73px';
            },

            async changeStatus(client) {
                this.client = client;

                await this.$store.dispatch('fetchClient', client.client_id);

                setTimeout(() => {
                    this.$bvModal.show('client_other');
                }, 1);
            },

            editClient(client_id) {
                this.edit = true;

                this.$store.dispatch('fetchEditClient', client_id)
                    .finally(response => {
                        this.$bvModal.show('client_form');
                    });
            },

            reReferral(client) {
                this.client = client;
                this.referralClicked = true;

                setTimeout(() => {
                    this.$bvModal.show('client_rereferral');
                }, 1);
            },

            deleteClient(client) {
                this.client = client;

                setTimeout(() => {
                    this.$bvModal.show('client_delete');
                }, 1);
            },
        },
    }
</script>

<style scoped>

</style>
